import type { WorkflowType } from './WorkflowType';

/**
 * Delivery type constants for safety actions.
 */
export const ACTION_DELIVERY_TYPES = {
  HTTP: 'http',
  SUBMIT_REPORT: 'submit_report',
} as const;

export type ActionDeliveryType = (typeof ACTION_DELIVERY_TYPES)[keyof typeof ACTION_DELIVERY_TYPES];

/**
 * Delivery settings interface.
 */
export interface DeliverySettings {
  url: string;

  postPayload?: string;
}

/**
 * Action label interface with severity threshold
 */
export interface ActionLabel {
  labelId: string;
  severity: number;
}

/**
 * Safety action interface.
 */
export interface SafetyAction {
  name: string;

  type?: string;

  description?: string;

  deliveryType: ActionDeliveryType;

  workflowType?: WorkflowType;

  labels?: ActionLabel[];

  policies?: string[];

  operatorName: string;

  deliverySettings?: DeliverySettings;
}

/**
 * Input interface for creating a safety action
 */
export interface CreateSafetyActionInput {
  name: string;
  type?: string;
  description?: string;
  deliveryType: ActionDeliveryType;
  labels: ActionLabel[];
  policies: string[];
  operatorName: string;
  deliverySettings?: DeliverySettings;
  workflowType: WorkflowType;
}

/**
 * Input interface for updating a safety action
 */
export interface UpdateSafetyActionInput {
  name?: string;
  type?: string;
  description?: string;
  deliveryType?: ActionDeliveryType;
  labels?: ActionLabel[];
  policies?: string[];
  operatorName?: string;
  deliverySettings?: DeliverySettings;
  workflowType?: WorkflowType;
}
